<template>
  <hs-dialog ref="Dialog" v-model="currentShow" :position="position" :positionHeight="positionHeight">
    <div class="starAndPriceDialog" :class="{ 'hs-filter-top': position === 'top', 'van-safe-area-bottom': position !== 'top' }" @click.stop>
      <c-dialog-header v-if="position !== 'top'" :title="!isInterHotel ? $t('PriceRating') : $t('PriceRating_1')" @close="$emit('update:show', false)"/>
      <hs-scroll class="table-view">
        <ul class="scroll-box">
          <div v-if="!(currency && Number(currency) !== 0)">
            <div class="item-header" style="margin-bottom: 8px">{{ $t('Price') }} <span
                v-if="priceHeaderTips">{{ priceHeaderTips }}</span></div>
            <div class="slider-box">
              <hs-slider
                  v-model="priceList"
                  :step="step"
                  :min="0"
                  :max="maxPrice"
                  active-color="#F0182A"
                  bar-height="3px"
                  button-size="20px"
                  range
                  @change="onChange"
                  minTips="￥0"
                  :maxTips="$t('RMBPriceOver_x', 'function', [maxPrice - step])"
              />
            </div>
            <div class="items">
              <hs-tag
                  v-for="(item, index) in priceItemList"
                  :key="index"
                  :title="item.text"
                  @click.native="selectPrice(item.value)"
                  :active="isSamePriceRange(item, priceList)"
              />
            </div>
          </div>
          <div v-else class="margin-top30"></div>
          <div>
            <div class="item-header">
              {{ OrderBusinessType === 2 ? $t('RatingMultipleChoice') : $t('DrillMultipleChoice') }}
            </div>
            <div class="items price-item">
              <hs-tag
                  v-for="(item, index) in starFilterItems"
                  :key="index"
                  :title="item.text"
                  :sub-title="item.subText"
                  :active="StarVal.split(',').indexOf(`${item.value}`) >= 0"
                  @click.native="selectStarFilterItem(item.value)"
              />
            </div>
          </div>
        </ul>
      </hs-scroll>
      <footer>
        <hs-button :type="'gray'" :disable="!canRet" fontSize="14px" width="calc(32% - 4px)" height="38px" @click="reset">{{$t('Reset')}}</hs-button>
        <hs-button width="calc(68% - 4px)" height="38px" fontSize="14px" @click="confirm">{{ $t('Confirm') }}</hs-button>
      </footer>
    </div>
  </hs-dialog>
</template>
<script type="text/ecmascript-6">
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsCell1 from 'base/hs-tableview/hs-cell-1/hs-cell-1'
import HsDialog from 'base/hs-dialog/hs-dialog'
import CDialogHeader from "@/components/c-header/c-dialog-header.vue";
import HsSlider from "@/base/hs-slider/hs-slider.vue";
import hsTag from "@/base/hs-tag/hs-tag.vue";
import {
  getPriceDes,
  getPriceRangeMinAndMax,
  interStarFilterItems, intlPriceFilterItems, isSamePriceRange, priceFilterItems,
  starItems
} from "@/components/c-filter/c-hotel-price-star";

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    StarRate: {
      type: String,
      default: ''
    },
    LowRate: {
      type: [Number, String],
      default: undefined
    },
    HighRate: {
      type: [Number, String],
      default: undefined
    },
    position: {
      type: String,
      default: ''
    },
    positionHeight: {
      type: String,
      default: ''
    },
    OrderBusinessType: {
      type: Number,
      default: 2
    },
    isInterHotel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currency() {
      return window.localStorage.currency || 0
    },
    currentShow: {
      get: function () {
        return this.show
      },
      set: function (val) {
        this.$emit('update:show', val)
      }
    },
    starFilterItems() {
      if (this.OrderBusinessType === 11) {
        return interStarFilterItems
      } else {
        return starItems
      }
    },
    priceHeaderTips() {
      return getPriceDes(this.priceList, this.maxPrice)
    },
    priceItemList() {
      return this.isInterHotel ? intlPriceFilterItems : priceFilterItems
    },
    step() {
      let val = this.isInterHotel ? 100 : 50
      return val
    },

    canRet() {
      return !(!this.priceHeaderTips && !this.StarVal)
    }
  },
  watch: {
    currentShow(val) {
      if (val) {
        this.StarVal = this.StarRate
        // position.value = props.position
        // positionHeight.value = props.positionHeight
        // OrderBusinessType.value = props.OrderBusinessType
        if (this.isInterHotel) {
          this.maxPrice = 1900
        } else {
          this.maxPrice = 1050
        }
        this.priceList = [this.LowRate || 0, this.HighRate || this.maxPrice]
      }
    }
  },
  data() {
    return {
      priceFilterItems,
      maxPrice: 1050,
      priceList: [0, 1050],
      StarVal: ''
    }
  },
  methods: {
    isSamePriceRange,
    onChange(value) {
      this.priceList = value
    },
    selectPrice(index) {
      let priceItem = getPriceRangeMinAndMax(index, this.isInterHotel)
      if (isSamePriceRange(priceItem, this.priceList)) {
        this.priceList = [0, this.maxPrice]
      } else {
        this.priceList = [priceItem.min, priceItem.max]
      }
    },
    selectStarFilterItem(value) {
      let list = this.noValue(this.StarVal) ? [] : this.StarVal.split(',')
      let indexInList = list.indexOf(`${value}`)
      indexInList >= 0 ? list.splice(indexInList, 1) : list.push(value)
      this.StarVal = list.join(',')
    },

    reset() {
      this.StarVal = ''
      this.priceList = [0, this.maxPrice]
    },

    confirm() {
      let item = this.priceList
      let min = item[0]
      let max = item[1]
      if (Number(item[1]) === this.maxPrice) {
        max = undefined
      }
      this.$emit('delegate', [min, max], this.StarVal)
      this.close()
    },

    /** 关闭 */
    close() {
      this.$refs.Dialog && this.$refs.Dialog.close()
    }
  },
  components: {
    HsButton: () => import('base/hs-button/hs-button'),
    CDialogHeader,
    HsSlider,
    hsTag,
    HsScroll,
    HsCell1,
    HsDialog
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.starAndPriceDialog {
  @extend .flex-column;
  @extend .flex-end;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: $color_black_0;
  max-height: calc(100% - 120px);
  overflow-y: auto;
  border-radius: 10px 10px 0 0;

  &.hs-filter-top {
    bottom: auto;
    top: 0;
    border-radius: 0 0 10px 10px;
  }

  .table-view {
    width: 100%;
    max-height: calc(100vh - 200px);
    overflow: hidden;
  }

  .scroll-box {
    padding: 1px 0;

    > div {
      width: 100%;
      padding: 0 12px;

      > .item-header {
        @extend .flex-row;
        @extend .flex-start;
        @extend .hs-font-subtitle-middle;
        width: 100%;
        padding: 16px 0 12px 0;
        color: $color_black_900;

        > span {
          margin-left: 8px;
          color: $color_theme_300;
        }
      }

      > .slider-box {
        margin-bottom: 24px;
      }

      > .items {
        @extend .flex-row;
        @extend .flex-start;
        @extend .flex-top;
        flex-wrap: wrap;
        width: 100%;
        align-items: stretch;
        justify-content: space-between;

        &.price-item {
          > .hs-tag {
            height: 56px;
          }
        }
      }
    }
  }

  footer {
    @extend .flex-between;
    width: 100%;
    box-shadow: 0 5px 10px $color_gray_layer;
    padding: 16px 12px;
    margin-bottom: 0;

    .hs-button {
      border-radius: 8px;
    }
  }
}
</style>
